import Axios from './Axios';

const API_URL = '/subscription/';

export const SubscriptionApi = {
    getList: () => Axios.get(API_URL + `list`),
    add: (payload) => Axios.post(API_URL + 'add', payload),
    edit: (payload) => Axios.put(API_URL + 'update', payload),
    delete: (id) => Axios.delete(API_URL + id)
}